/**
 * StatCard - Reusable stat card component for displaying metrics
 *
 * Atomic level: Molecule
 * Composes: Badge (optional)
 *
 * Displays a label and value in a compact, uniform card format
 * Following GO UI Design System patterns
 */

import React from 'react';
import { cn } from '../../../../lib/utils';
import { Badge } from '../../../ui/badge';

export interface StatCardProps {
  label: string;
  value: React.ReactNode;
  badge?: string;
  className?: string;
}

const StatCard: React.FC<StatCardProps> = ({ label, value, badge, className }) => {
  return (
    <div className={cn('flex flex-col gap-1', className)}>
      <div className="text-sm font-medium text-muted-foreground">{label}</div>
      <div className="flex items-center gap-2">
        {typeof value === 'string' || typeof value === 'number' ? (
          <span className="text-3xl font-bold tabular-nums leading-none">
            {typeof value === 'number' ? value.toLocaleString() : value}
          </span>
        ) : (
          value
        )}
        {badge && (
          <Badge variant="outline" className="text-xs px-2 py-0.5">
            {badge}
          </Badge>
        )}
      </div>
    </div>
  );
};

export { StatCard };
